var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMyReservation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 5V3.5A1.5 1.5 0 0 0 13.5 2h-2v-.5a.5.5 0 0 0-1 0V2h-5v-.5a.5.5 0 1 0-1 0V2h-2A1.5 1.5 0 0 0 1 3.5V5h14ZM1 6v7.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5V6H1Zm9.825 2.88-3.5 3a.5.5 0 0 1-.679-.027l-1.5-1.5a.5.5 0 0 1 .708-.707l1.173 1.173 3.15-2.7a.5.5 0 1 1 .65.76h-.002Z",
  fill: "#003A8C"
})));
export default SvgMyReservation;